import { EventSubPageTitle } from '../breadcrumbs/EventSubPageTitle';

export const EventPublishConfirmationPageNav = (): React.ReactElement<any, any> | null => {
    return <EventSubPageTitle>Publish confirmation</EventSubPageTitle>;
};
